import { LotteryConfigModel } from "../models/lottery-configuration-model";

export const baseConfig: LotteryConfigModel = {
    lottery: null,
    boardCount: null,
    primaryBoardSize: null,
    defaultStake: null,
    boardLabel: null,
    primaryNumbers: null,

    secondaryBoardSize: null,
    secondaryNumbers: null,

    tertiaryBoardSize: null,
    tertiaryNumbers: null,

    addonBoardSize: null,
    addonNumbers: null,

    primarySystemMaxCount: null,
    secondarySystemMaxCount: null,

    primaryMinBoardSize: null,
    stakeOptions: [],

    hasDurationComponent: null,
    durationTitle: null,
    hasDrawOptions: null,
    hasAllOrOneMultidrawOptions: null,
    hasMultidrawNotification: null,
    hasDurationInDays: null,
    hasSubscription: null,
    multidrawDurationOptions: [],
    maxDuration: null,
    isDrawnEveryDay: null,
};
